export default __webpack_public_path__ + "static/media/answer-panel.6d051bff.mp3";